class TestimonialsV2Carousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.jp-tv2__track');
    this.cards = Array.from(this.querySelectorAll('.jp-tv2__card'));

    if (!this.track || !this.cards.length) return;

    this.activeIndex = Math.floor(this.cards.length / 2);
    this.isDragging = false;
    this.dragMoved = false;
    this.startX = 0;
    this.startScrollLeft = 0;

    this.updateActive();
    requestAnimationFrame(() => requestAnimationFrame(() => this.scrollToActive(false)));

    this.track.addEventListener('mousedown', this.onMouseDown.bind(this));
    window.addEventListener('mousemove', this.onMouseMove.bind(this));
    window.addEventListener('mouseup', this.onMouseUp.bind(this));
    this.track.addEventListener('dragstart', (e) => e.preventDefault());

    this.track.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
    this.track.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
  }

  updateActive() {
    this.cards.forEach((card, i) => card.classList.toggle('is-active', i === this.activeIndex));
  }

  scrollToActive(smooth) {
    const card = this.cards[this.activeIndex];
    if (!card) return;
    this.track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    const scrollLeft = card.offsetLeft - this.track.offsetWidth / 2 + card.offsetWidth / 2;
    this.track.scrollLeft = scrollLeft;
  }

  snapToNearest() {
    const center = this.track.scrollLeft + this.track.offsetWidth / 2;
    let closest = 0;
    let minDist = Infinity;
    this.cards.forEach((card, i) => {
      const dist = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    this.activeIndex = closest;
    this.updateActive();
    this.scrollToActive(true);
  }

  onMouseDown(e) {
    if (e.button !== 0) return;
    this.isDragging = true;
    this.dragMoved = false;
    this.startX = e.clientX;
    this.startScrollLeft = this.track.scrollLeft;
    this.track.classList.add('is-dragging');
    this.track.style.scrollBehavior = 'auto';
  }

  onMouseMove(e) {
    if (!this.isDragging) return;
    const delta = e.clientX - this.startX;
    if (Math.abs(delta) > 5) this.dragMoved = true;
    this.track.scrollLeft = this.startScrollLeft - delta;
  }

  onMouseUp() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.classList.remove('is-dragging');
    if (this.dragMoved) this.snapToNearest();
  }

  onTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
  }

  onTouchEnd(e) {
    const delta = e.changedTouches[0].clientX - this.touchStartX;
    if (Math.abs(delta) > 40) {
      this.activeIndex = Math.max(0, Math.min(this.cards.length - 1, this.activeIndex + (delta < 0 ? 1 : -1)));
      this.updateActive();
      this.scrollToActive(true);
    }
  }
}

customElements.define('testimonials-v2-carousel', TestimonialsV2Carousel);
